module.exports = __webpack_public_path__ + "img/services-alb.a6bd3f30.svg";